import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSurveyForm,
  updateSurveyParticipantResponsesStatus,
} from "../../Utils/surveyFunctions";
import { ToastContainer, toast } from "react-toastify";
let SurveyConsent = () => {
  const { ip_address } = useContext(globalInfo);
  const { formKey } = useParams();
  const navigate = useNavigate();
  const [consent, setConsent] = useState("");
  const [surveyID, setSurveyID] = useState("");
  const [participantID, setParticipantID] = useState("");
  const [isactive, setIsactive] = useState("");
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSurveyForm(formKey);
      if (response.status == "success") {
        if (
          response.getSurveyStatus === "completed" ||
          response.getSurveyStatus === "survey_closed" ||
          response.getSurveyStatus === "final_save" ||
          response.getSurveyStatus === "survey_approved"
        ) {
          navigate("/SurveyClosed");
          return false;
        } else if (
          response.getParticipantLastAction.includes("survey_attempted")
        ) {
          navigate("/survey-already-taken");
          return false;
        } else if (response.getParticipantLastAction.includes("disqualified")) {
          navigate("/SurveyNotEligible");
          return false;
        }
        setConsent(response.getConsent);
        setSurveyID(response.getSurveyID);
        setParticipantID(response.getParticipantID);
      } else {
        setIsactive("disabled");
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);
  const surveyResponcseStatusAction = async (action) => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("participant_id", participantID);
    bodyFormData.append("status", action);
    bodyFormData.append("ip_address", ip_address);
    const response = await updateSurveyParticipantResponsesStatus(bodyFormData);
    if (response.status == "success") {
      if (action === "disclaimer_agreed") {
        navigate("/SurveyForm/" + formKey);
      } else {
        navigate("/SurveyNotEligible");
      }
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <ToastContainer></ToastContainer>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className="fade show" id="modal-default" arial-modal="true">
            <input type="hidden" id="deleteListsite" value=""></input>
            <div
              className="modal-dialog custom-modal-consent"
              style={{ background: "#fff" }}
            >
              <div className="modal-content p-3">
                <div className="modal-body">
                  <h5>
                    <strong>Consent</strong>
                    <hr />
                  </h5>

                  <p>{consent}</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-sm custom-btn-primary pull-right mr-2"
                    onClick={() =>
                      surveyResponcseStatusAction("disclaimer_agreed")
                    }
                    disabled={isactive}
                  >
                    Agree
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-dark pull-right"
                    onClick={() =>
                      surveyResponcseStatusAction("disclaimer_disagreed")
                    }
                    disabled={isactive}
                  >
                    Disagree
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyConsent;
